/** Icônes SVG admin — stroke cohérent, sans dépendance externe. */

import type { ReactNode } from 'react';

type IconProps = { className?: string; size?: number };

function Svg({ size = 18, className, children }: IconProps & { children: ReactNode }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.85"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {children}
    </svg>
  );
}

export function IconLayout({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </Svg>
  );
}

export function IconUsers({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Svg>
  );
}

export function IconShield({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    </Svg>
  );
}

export function IconFolder({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </Svg>
  );
}

export function IconCalendar({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </Svg>
  );
}

export function IconTrophy({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 0 1-10 0V4Z" />
      <path d="M5 8H4a2 2 0 0 1-2-2V5h3M19 8h1a2 2 0 0 0 2-2V5h-3" />
    </Svg>
  );
}

export function IconGlobe({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" />
    </Svg>
  );
}

export function IconLifeBuoy({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <path d="m4.9 4.9 3.4 3.4M15.7 15.7l3.4 3.4M15.7 8.3l3.4-3.4M4.9 19.1l3.4-3.4" />
    </Svg>
  );
}

export function IconHandshake({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="m11 17 2 2a1 1 0 1 0 3-3" />
      <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.9-3.9a2 2 0 0 0-2.8 0L9 13" />
      <path d="M3 11 8.5 5.5a2 2 0 0 1 2.8 0L14 8" />
      <path d="m7 17 2.5-2.5" />
    </Svg>
  );
}

export function IconStore({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="m2 7 4.4-4.4A2 2 0 0 1 7.8 2h8.4a2 2 0 0 1 1.4.6L22 7" />
      <path d="M4 12v8a1 1 0 0 0 1 1h4v-5h6v5h4a1 1 0 0 0 1-1v-8" />
      <path d="M2 7h20v3a3 3 0 0 1-3 3 3 3 0 0 1-3-3 3 3 0 0 1-3 3 3 3 0 0 1-3-3 3 3 0 0 1-3 3 3 3 0 0 1-3-3V7Z" />
    </Svg>
  );
}

export function IconGift({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13M19 12v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
    </Svg>
  );
}

export function IconShare({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4" />
    </Svg>
  );
}

export function IconMail({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-10 7L2 7" />
    </Svg>
  );
}

export function IconBell({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </Svg>
  );
}

export function IconMenu({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M4 6h16M4 12h16M4 18h16" />
    </Svg>
  );
}

export function IconX({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M18 6 6 18M6 6l12 12" />
    </Svg>
  );
}

export function IconSearch({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </Svg>
  );
}

export function IconInbox({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </Svg>
  );
}

export function IconPen({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </Svg>
  );
}

export function IconChart({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M3 3v18h18" />
      <path d="M7 16v-5M12 16V8M17 16v-9" />
    </Svg>
  );
}

export function IconUser({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </Svg>
  );
}

export function IconCredit({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20" />
    </Svg>
  );
}

export function IconLogout({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="M16 17l5-5-5-5M21 12H9" />
    </Svg>
  );
}

export function IconLock({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </Svg>
  );
}

export function IconChevronRight({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="m9 18 6-6-6-6" />
    </Svg>
  );
}

export function IconBook({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </Svg>
  );
}

export function IconMore({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className}>
      <circle cx="5" cy="12" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1.6" fill="currentColor" stroke="none" />
    </Svg>
  );
}

export type AdminIconName =
  | 'layout'
  | 'users'
  | 'shield'
  | 'folder'
  | 'calendar'
  | 'trophy'
  | 'globe'
  | 'lifebuoy'
  | 'handshake'
  | 'store'
  | 'gift'
  | 'share'
  | 'mail'
  | 'bell'
  | 'menu'
  | 'search'
  | 'inbox'
  | 'pen'
  | 'chart'
  | 'user'
  | 'credit'
  | 'logout'
  | 'lock'
  | 'chevronRight'
  | 'book'
  | 'x'
  | 'more';

const ICON_MAP: Record<AdminIconName, (p: IconProps) => ReactNode> = {
  layout: IconLayout,
  users: IconUsers,
  shield: IconShield,
  folder: IconFolder,
  calendar: IconCalendar,
  trophy: IconTrophy,
  globe: IconGlobe,
  lifebuoy: IconLifeBuoy,
  handshake: IconHandshake,
  store: IconStore,
  gift: IconGift,
  share: IconShare,
  mail: IconMail,
  bell: IconBell,
  menu: IconMenu,
  search: IconSearch,
  inbox: IconInbox,
  pen: IconPen,
  chart: IconChart,
  user: IconUser,
  credit: IconCredit,
  logout: IconLogout,
  lock: IconLock,
  chevronRight: IconChevronRight,
  book: IconBook,
  x: IconX,
  more: IconMore,
};

export function AdminIcon({ name, size = 18, className }: IconProps & { name: AdminIconName }) {
  const Comp = ICON_MAP[name];
  return <>{Comp({ size, className })}</>;
}
